<div class="box-theme">
  <div class="head">
    <div class="body">
      <h2>Conoce el centro de Ayuda Online de Metrogas</h2>
    </div>
  </div>
  <div class="body">
    <div class="body">
      <div class="row">
        <div class="col-xs-12">
          <div class="video-vimeo ">
            <div class="video-responsive">
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/_bWfpZ-C8DM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="body">
    <div class="footer">
      <div class="header text-center">
        <input type="button" value="Elige tu requerimiento" class="btn btn-continuar btn-elite-tu-requerimiento" [routerLink]="['/home']">
      </div>
    </div>
  </div>
</div>